import { gql } from "@apollo/client";

export const CLIENT_ASSIGNMENTS = gql`
  query Dashboard {
    dashboard {
      assignedClients
      clients
      unAssignedClients
    }
  }
`;

export const PAYROLL_OVERVIEW_CHART_DATA = gql`
  query PayrollOverview($clientId: [String], $year: Int, $month: Int) {
    payrollOverview(client_ids: $clientId, year: $year, month: $month) {
      month
      data {
        payslipRelesed
        payrollLock
        headCount
      }
      year
      client_id
      updatedAt
    }
  }
`;

export const GET_CLIENT_TRENDS = gql`
  query ActiveClientsLog($startDate: String, $endDate: String) {
    activeClientsLog(startDate: $startDate, endDate: $endDate) {
      logs {
        active_count
        updatedAt
      }
    }
  }
`;

export const SYNC_DASHBOARD = gql`
  mutation Mutation {
    synClientDashboardData
  }
`;

export const SAVE_GLOBAL_SEARCH = gql`
  mutation GlobalSearchLog($type: String!, $globalSearchLogId: String!) {
    globalSearchLog(type: $type, id: $globalSearchLogId)
  }
`;

export const GET_RECENT_SEARCHES = gql`
  query RecentSearchLog {
    recentSearchLog {
      clients {
        _id
        name
        client_id
        url
      }
      users {
        _id
        email
        first_name
        last_name
        profile_pic
      }
    }
  }
`;
